import { Injectable } from '@angular/core';
import { AuthData } from '../providers/auth';
import * as firebase from 'firebase';

@Injectable()

export class StorageFb {

  constructor(public auth: AuthData) {
  }

  uploadNote(file) {

    return new Promise((resolve, reject) => {
      resolve(firebase.storage().ref('/Notes/' + this.auth.getUser().uid + '/' + file.name).put(file));
    });
  }

  uploadAvatar(client, file) {

    return new Promise((resolve, reject) => {
      resolve(firebase.storage().ref('/Clients/' + client.id + '/Profile/' + this.auth.getUser().uid + '/' + file.name).put(file));
    });
  }
}
// end file



// WEBPACK FOOTER //
// ./src/providers/storage.ts